const OFFICIAL_LANGUAGE_OPTIONS = [
  'Zulu',
  'Xhosa',
  'Afrikaans',
  'English',
  'Sepedi (Northern Sotho)',
  'Tswana',
  'Sesotho (Southern Sotho)',
  'Xitsonga',
  'siSwati',
  'Tshivenda',
  'isiNdebele',
  'South African Sign Language (SASL)',
  'Other',
];

const OFFICIAL_LANGUAGE_ALIASES = {
  zulu: 'Zulu',
  isizulu: 'Zulu',
  xhosa: 'Xhosa',
  isixhosa: 'Xhosa',
  afrikaans: 'Afrikaans',
  english: 'English',
  sepedi: 'Sepedi (Northern Sotho)',
  'northern sotho': 'Sepedi (Northern Sotho)',
  'sepedi (northern sotho)': 'Sepedi (Northern Sotho)',
  tswana: 'Tswana',
  setswana: 'Tswana',
  'sesotho (southern sotho)': 'Sesotho (Southern Sotho)',
  sesotho: 'Sesotho (Southern Sotho)',
  sotho: 'Sesotho (Southern Sotho)',
  xitsonga: 'Xitsonga',
  tsonga: 'Xitsonga',
  siswati: 'siSwati',
  swati: 'siSwati',
  tshivenda: 'Tshivenda',
  venda: 'Tshivenda',
  isindebele: 'isiNdebele',
  ndebele: 'isiNdebele',
  'south african sign language': 'South African Sign Language (SASL)',
  'south african sign language (sasl)': 'South African Sign Language (SASL)',
  sasl: 'South African Sign Language (SASL)',
  other: 'Other',
};

const LANGUAGE_PROFICIENCY_OPTIONS = ['Good', 'Fair', 'Poor'];

const LANGUAGE_PROFICIENCY_ALIASES = {
  good: 'Good',
  excellent: 'Good',
  advanced: 'Good',
  fluent: 'Good',
  'home language': 'Good',
  'home-language': 'Good',
  home_language: 'Good',
  'very good': 'Good',
  true: 'Good',
  yes: 'Good',
  '1': 'Good',
  fair: 'Fair',
  intermediate: 'Fair',
  average: 'Fair',
  medium: 'Fair',
  moderate: 'Fair',
  poor: 'Poor',
  basic: 'Poor',
  limited: 'Poor',
  beginner: 'Poor',
  elementary: 'Poor',
  false: 'Poor',
  no: 'Poor',
  '0': 'Poor',
};

function normalize_lookup_key(value) {
  return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
}

export function get_official_language_options() {
  return OFFICIAL_LANGUAGE_OPTIONS.map((item) => ({
    text: item,
    value: item,
  }));
}

export function get_language_proficiency_options() {
  return LANGUAGE_PROFICIENCY_OPTIONS.map((item) => ({
    text: item,
    value: item,
  }));
}

export function normalize_official_language_value(raw_value) {
  const normalized_key = normalize_lookup_key(raw_value);
  if (!normalized_key) {
    return '';
  }

  return OFFICIAL_LANGUAGE_ALIASES[normalized_key] || String(raw_value).trim();
}

export function normalize_language_proficiency_value(raw_value) {
  const normalized_key = normalize_lookup_key(raw_value);
  if (!normalized_key) {
    return '';
  }

  return LANGUAGE_PROFICIENCY_ALIASES[normalized_key] || String(raw_value).trim();
}

export function map_language_selection_value(raw_value) {
  const normalized = normalize_official_language_value(raw_value);
  if (!normalized) {
    return { editable_value: '', other_value: '' };
  }

  const has_match = OFFICIAL_LANGUAGE_OPTIONS.includes(normalized);
  if (has_match) {
    return { editable_value: normalized, other_value: '' };
  }

  return {
    editable_value: 'Other',
    other_value: String(raw_value || '').trim(),
  };
}